<div class="quit-header">
  <app-cancel quitButtonVariant="ghost" [isTransparent]="true"></app-cancel>
</div>
